module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-6.c799911f.jpg";